/** The Deleg8 mark: a D with a hand-off arrow. */
export function Brand({ size = 30, mark }: { size?: number; mark?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true">
        <rect width="32" height="32" rx="9" fill="var(--accent)" />
        <path d="M9 10h6a6 6 0 0 1 0 12H9z" fill="none" stroke="var(--accent-ink)" strokeWidth="2.6" />
        <path d="M19 16h5m-2.5-2.5L24 16l-2.5 2.5" fill="none" stroke="var(--accent-ink)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {mark ? null : <span className="font-semibold tracking-tight" style={{ fontSize: size * 0.6 }}>Deleg<span className="text-accent">8</span></span>}
    </span>
  );
}
